import axios from 'axios';
import quranapi from './myquranapi.json'
import quranquestions from './quranquestions.json'
import manhaj from './manhaj.json'


export const quranApi = () => {
  return quranapi;
}

export const quranManhaj = () => {
  return manhaj;
}


export const quranQuestionsApi = () => {
  return quranquestions;
}


export const getPage = (page) => {
  let res = quranApi().filter(p => p.page === page)
  return res;
}

export const getVerseByvid = async(verseid) => {
  let res = await quranApi().filter(p => p.vid === verseid)
  return res;
}

export const getData = (key, value) => {
  let res = quranApi().filter(p => p[key] === value)
  return res;
}

export const getPaged = async (page) => {
  let api = `https://cdn.jsdelivr.net/gh/fawazahmed0/quran-api@1/editions/ara-quranacademy/pages/${page}.json`
  let res = await axios.get(api);
  return res?.data;
}

export const getQuestions = (key, value, key2, value2, key3, value3) => {
  if (!!key3) {
    let res = quranQuestionsApi().filter(p => p[key] === value && p[key2] === value2 && p[key3] === value3)
    return res;
  }
  if (!!key2) {
    let res = quranQuestionsApi().filter(p => p[key] === value && p[key2] === value2)
    return res;
  }
  if (!!key) {
    let res = quranQuestionsApi().filter(p => p[key] === value)
    return res;
  }
  return { error: "not found" };
}

export const filterQuestions = (key, valuestart, valueend) => {
  if (!!key) {
    let res = quranQuestionsApi().filter(p => p[key] >= valuestart && p[key] <= valueend)
    return res;
  }
  return { error: "not found" };
}

export const filterQuestionsByGrade = (grade, gofi) => {
  if (!!grade) {
    let valuestart = getManhaj(grade, gofi)?.start;
    let valueend = getManhaj(grade, gofi)?.end;
    let res = quranQuestionsApi().filter(p => p.vid >= valuestart && p.vid <= valueend)
    return res;
  }
  return { error: "not found" };
}

export const getManhaj = (grade, gofi) => {
  if (!!grade) {
    let start = quranManhaj().find(g => g.grade.toString() === grade.toString())[gofi].split("|")[0];
    let end = quranManhaj().find(g => g.grade.toString() === grade.toString())[gofi].split("|")[1];
    return {
      start: start, end: end
    }
  }
}